import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';

import { RecommendOptionValueModel } from '../utils/types';

export interface SimilarSizeOptionProps {
  ranking: RecommendOptionValueModel['ranking'];
  name: RecommendOptionValueModel['name'];
  purchasePercent: RecommendOptionValueModel['purchasePercent'];
  answer: RecommendOptionValueModel['answer'];
}

export function SimilarSizeOption({ ranking, name, purchasePercent, answer }: SimilarSizeOptionProps) {
  return (
    <Wrapper>
      <Item>
        <Left>
          <Number className={Typography.CAPTION_12_SEMIBOLD}>{ranking}</Number>
          <Option className={Typography.BODY_16_MEDIUM}>{name}</Option>
        </Left>
        <Right className={Typography.BODY_16_REGULAR}>
          {purchasePercent && <div>{purchasePercent}%가 구매</div>}
          {answer && (
            <Detail className={Typography.BODY_13_REGULAR}>
              리뷰 {answer.percent}&#37; <Dot>&#183;</Dot> {answer.value}
            </Detail>
          )}
        </Right>
      </Item>
    </Wrapper>
  );
}

const Wrapper = styled.li`
  padding: 16px 0;
  border-bottom: 1px solid ${vars.v3Color.gray100};
  &:last-of-type {
    border-bottom: none;
  }
`;

const Item = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Left = styled.div`
  display: flex;
  flex-shrink: 1;
  overflow: hidden;
`;

const Right = styled.div`
  display: flex;
  flex: 0 0 127px;
  flex-direction: column;
  align-items: flex-end;
`;

const Number = styled.span`
  width: 18px;
  height: 18px;
  margin-right: 12px;
  background-color: ${vars.v3Color.gray200};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  color: #ffffff;
  line-height: normal;
`;

const Option = styled.span`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

const Detail = styled.div`
  padding: 3px 0 0 0;
  text-align: right;
  color: ${vars.v3Color.gray400};
  white-space: nowrap;
`;

const Dot = styled.span`
  color: ${vars.v3Color.gray200};
`;
